import {
    Alert,
    Badge,
    Card,
    Col,
    OverlayTrigger,
    Row,
    Table,
    Tooltip,
} from "react-bootstrap";
import { getTimeRange } from "../../../../utils/timeFormatter";
import { PlusSquare } from "react-feather";

const TpmrBatchDetails = ({
    batchId,
    name,
    courseName,
    type,
    date,
    testVenue,
    trainingVenue,
    status,
    trainingDates = [],
    adhocTrainingDates = [],
}) => {
    const practicalDates =
        trainingDates?.filter((date) => date.training_type === "practical") ||
        [];

    const adhocDates =
        adhocTrainingDates?.filter(
            (date) => date.training_type === "practical"
        ) || [];

    const allDates = [
        ...practicalDates.map((date, i) => ({
            ...date,
            type: "P",
            index: i + 1,
        })),
        ...adhocDates.map((date, i) => ({
            ...date,
            type: "AP",
            index: 1 + 1,
        })),
    ];

    return (
        <Card>
            <Card.Header className="h4 fw-bold">
                <Row>{name}</Row>
            </Card.Header>

            <Card.Body>
                <Row className="mb-2">
                    <Col>
                        <strong>Type:</strong> {type?.toUpperCase()}
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <strong>Test Date:</strong> {date}
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col>
                        <strong>Test Venue:</strong>{" "}
                        {testVenue?.join(", ") || ""}
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col>
                        <strong>Training Venue:</strong>{" "}
                        {trainingVenue?.join(", ") || ""}
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col>
                        <strong>Status:</strong> <Badge>{status}</Badge>
                    </Col>
                </Row>

                <Row className="mb-2">
                    <Col>
                        <strong>Course:</strong> {courseName}
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col>
                        {allDates.length > 0 ? (
                            <Table size="sm" bordered>
                                <tbody>
                                    <tr>
                                        <td colSpan={2} className="fw-bold">
                                            Training Dates
                                        </td>
                                    </tr>
                                    {practicalDates.map((td, i) => (
                                        <tr key={i}>
                                            <td>{`P${i + 1}`}</td>
                                            <td>
                                                {td?.date + getTimeRange(td) ??
                                                    "-"}
                                            </td>
                                        </tr>
                                    ))}
                                    {adhocDates.map((td, i) => (
                                        <tr key={i}>
                                            <td>{`AP${i + 1}`}</td>
                                            <td>
                                                {td?.date + getTimeRange(td) ??
                                                    "-"}
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan={2}>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={
                                                    <Tooltip>
                                                        {" "}
                                                        Add adhoc training dates
                                                    </Tooltip>
                                                }
                                            >
                                                <a
                                                    href={`/tms/batches/${batchId}/tpmr-adhoc-training-dates`}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="me-1"
                                                >
                                                    <span>
                                                        <PlusSquare
                                                            size="24"
                                                            color="#6c757d"
                                                        />
                                                    </span>
                                                </a>
                                            </OverlayTrigger>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        ) : (
                            <Alert className="my-3" variant="info">
                                <div className="alert-message">
                                    No practical training dates on this class.
                                </div>
                            </Alert>
                        )}
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};

export default TpmrBatchDetails;
